module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-loader-spinner/index.js
// module id = 487
// module chunks = 1